import type { SqlDatabaseType, SqlImportDatabase } from '@/services/db/sql-import-database/entity';
import type { DatabaseStepState } from '../use-database-step';
import { DatabaseForm } from './database-form';
import { DatabaseList } from './database-list';

type DatabaseStepProps = {
  type: SqlDatabaseType;
  databases: readonly SqlImportDatabase[];
  isReadOnly: boolean;
  sqlServerIp: string;
  state: DatabaseStepState;
};

/** The Database step: pick one of the workspace's saved databases, or open the form to add or fix one. */
export function DatabaseStep({ type, databases, isReadOnly, sqlServerIp, state }: DatabaseStepProps) {
  if (state.editor != null) {
    return (
      <DatabaseForm
        key={state.editor.mode === 'edit' ? state.editor.database.id : 'new'}
        type={type}
        database={state.editor.mode === 'edit' ? state.editor.database : undefined}
        canCancel={databases.length > 0}
        isReadOnly={isReadOnly}
        isSaving={state.isSaving}
        connectionError={state.connectionError}
        sqlServerIp={sqlServerIp}
        onCancel={state.cancelEdit}
        onSave={state.saveDatabase}
      />
    );
  }
  return (
    <DatabaseList
      type={type}
      databases={databases}
      selectedId={state.selected?.id}
      isReadOnly={isReadOnly}
      onSelect={state.select}
      onAdd={state.startAdd}
      onEdit={state.startEdit}
      onDelete={state.confirmDelete}
    />
  );
}
